import { Navbar } from "../components/Navbar";
import { DocumentsSection } from "../components/DocumentsSection";
import { Footer } from "../components/Footer";
import { SEO } from "../components/SEO";
import { useLang } from "../i18n/LanguageContext";

export default function DocumentsPage() {
  const { t } = useLang();
  return (
    <div className="bg-mist min-h-screen" data-testid="documents-page">
      <SEO title={t("nav_documents")} description={t("docs_sub")} path="/belgeler" />
      <Navbar />
      <div className="pt-16">
        <DocumentsSection full />
      </div>
      <Footer />
    </div>
  );
}
